
import React from "react";
import Main from "./Main/main";

function RequestForm() {
  return (
    <div>
      <Main />
    </div>
  );
}

export default RequestForm;
